import { Link } from "react-router-dom";

export default function HeroSection() {
  const scrollToNews = () => {
    const newsElement = document.getElementById('recent-news-section');
    if (newsElement) {
      newsElement.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section 
      className="hero relative w-full min-h-[550px] sm:min-h-[700px] md:min-h-[700px]"
      style={{
        backgroundImage: "linear-gradient(to right, rgba(10,22,51,0.85), rgba(10,22,51,0.6), rgba(10,22,51,0.2)), url('/images/chess.png')",
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      }}
    >
      <div className="hero-content relative text-white px-6 sm:px-20 pt-24 sm:pt-32 max-w-3xl" style={{ textShadow: '0 2px 4px rgba(0,0,0,0.3)' }}>
        <h1 className="text-3xl sm:text-4xl md:text-5xl mb-4 sm:mb-6 font-poppins leading-tight" style={{ textShadow: '0 2px 4px rgba(0,0,0,0.3)' }}>
          Ranipet District <br /> Chess Academy
        </h1>

        <p className="text-[#CBD5E1] text-base sm:text-lg mb-6 sm:mb-8 max-w-lg leading-relaxed">
          Promoting chess excellence and nurturing young talents across
          Ranipet district with world-class training and competitive opportunities.
        </p>

        <div className="flex flex-col sm:flex-row gap-3 sm:gap-4">
          <Link 
            to="/about"
            className="primary bg-[#3B82F6] text-white px-6 sm:px-8 py-3 sm:py-4 rounded-lg font-semibold hover:bg-[#2563EB] hover:shadow-xl hover:scale-105 transition-all duration-300 w-full sm:w-auto inline-block text-center"
          >
            Discover More
          </Link>
          <button 
            onClick={scrollToNews}
            className="secondary bg-transparent text-white border-2 border-white px-6 sm:px-8 py-3 sm:py-4 rounded-lg font-semibold hover:bg-white/10 hover:border-[#3B82F6] hover:text-[#3B82F6] transition-all duration-300 w-full sm:w-auto inline-block text-center"
          >
            Latest News
          </button>
        </div>
      </div>
    </section>
  );
}